import React, { useEffect, useState } from 'react';
import Datatable from '../../components/Datatable';
import FormDialog, { Text } from '../../components/Datatable/FormDialog';
import { Box, Button, IconButton, Snackbar, TextField, Tooltip, Typography, Switch, FormControlLabel, setRef, Chip, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { create, get_one, update, delete_one } from '../../services/api';
import EditIcon from '@mui/icons-material/Edit';
import { useNotify } from '../../components/Datatable/NotifyProvider';
import { useFormError } from '../../components/Datatable/FormErrorProvider';
import { RemoveCircleOutline } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from '../../components/AuthProvider';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { red, green } from '@mui/material/colors';
import KeyIcon from '@mui/icons-material/Key';
import CircularProgress from '@mui/material/CircularProgress';
import api from '../../services/api';
import Backdrop from '@mui/material/Backdrop';
import SyncIcon from '@mui/icons-material/Sync';
import { useLoading } from '../../components/LoadingProvider';
import Swal from 'sweetalert2';
import { handleQueuedResponse } from '../../utils/handleQueuedResponse';

// Papel do nó (backend: app/oceanide/models.py NODE_ROLES). Papel é do
// servidor; define o que o sync escreve nele.
const ROLES = {
    recursive: { label: 'Recursivo', color: 'info',    help: 'Recebe ACL, lista de bloqueio e zonas locais.' },
    reverse:   { label: 'Reverso',   color: 'warning', help: 'Só recebe zonas reversas. Não recebe ACL, bloqueio nem zonas locais.' },
}

export default function Node() {
    const notify = useNotify()
    const auth = useAuth()
    const loading = useLoading()
    const { isLoading, setLoading } = loading

    const [formState, setFormState] = useState({
        open: false,
        id: null,
    })
    const [refresh, setRefresh] = useState(false)
    React.useEffect(() => {
        document.title = "IPV7 Tools - DNS Servidores DNS"
    }, [])
    return (
        <>
        
            <FormItem
                open={formState.open}
                id={formState.id}
                handlerClose={() => setFormState({ open: false, id: null })}
                handlerSubmit={() => setRefresh(true)}
                btnSubmit={formState.id ? 'Atualizar' : 'Salvar'}
                btnClose={'Fechar'}
            ></FormItem>
            <Datatable
                refresh={refresh}
                handlerRefresh={() => setRefresh(!refresh)}
                title='Servidores DNS'
                endpoint='/dns/node'
                options={{
                    customToolbar: () =>
                        <>
                            <Tooltip title="Remover todos os filtros">
                                <IconButton onClick={() => { localStorage.removeItem("datatable" + "'/dns/node"); location.reload() }} >
                                    <RemoveCircleOutline />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Adicionar">
                                <IconButton disabled={!auth.hasPerm("dns_node.create")}
                                    onClick={() => setFormState({ open: true, id: null })}
                                >
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    ,
                    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => ""
                }
                }
                columns={[
                    {
                        name: 'id',
                        label: 'ID',
                        options: {
                            display: false
                        }
                    },
                    {
                        name: 'name',
                        label: 'Descrição',
                    },
                    {
                        name: 'ip',
                        label: 'IP',
                    },
                    {
                        name: 'port',
                        label: 'Porta',
                    },
                    {
                        name: 'role',
                        label: 'Papel',
                        options: {
                            customBodyRender: (value) => {
                                const r = ROLES[value] || ROLES.recursive
                                return <Chip size="small" variant="outlined" color={r.color} label={r.label} />
                            }
                        }
                    },
                    {
                        name: 'active',
                        label: 'Ativo',
                        options: {
                            customBodyRender: (value, tableMeta) => {
                                const id = tableMeta.rowData[0]
                                return (
                                    <Tooltip title={value ? 'Nó participa das syncs' : 'Nó pulado nas syncs'}>
                                        <Switch
                                            size="small"
                                            checked={!!value}
                                            disabled={!auth.hasPerm("dns_node.update")}
                                            onChange={async (e) => {
                                                try {
                                                    await api.post(`/dns/node/${id}/active`, { active: e.target.checked })
                                                    notify.setNotify({ open: true, message: e.target.checked ? 'Nó ativado' : 'Nó desativado', severity: 'success' })
                                                    setRefresh(r => !r)
                                                } catch (err) {
                                                    notify.setNotify({ open: true, message: err.response?.data?.detail || 'Erro ao alternar', severity: 'error' })
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                )
                            }
                        }
                    },
                    {
                        name: 'is_sync',
                        label: 'Sincronizado',
                        options: {
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return value ? <CheckIcon sx={{ color: green[500] }} /> : <CloseIcon sx={{ color: red[500] }} />
                            }
                        }
                    },
                    {
                        name: "is_credentials_valid",
                        label: "Login",
                        options: {
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return value ? <CheckIcon sx={{ color: green[500] }} /> : <CloseIcon sx={{ color: red[500] }} />
                            }

                        }
                    },
                    {
                        name: 'actions',
                        label: 'Ações',
                        options: {
                            filter: false,
                            sort: false,
                            customBodyRender: (value, tableMeta, updateValue) => {
                                return (
                                    <>
                                        <Tooltip title="Editar">
                                            <IconButton
                                                disabled={!auth.hasPerm("dns_node.update")}
                                                onClick={() => setFormState({ open: true, id: tableMeta.rowData[0] })}
                                            >
                                                <EditIcon />

                                            </IconButton>
                                        </Tooltip>
                                       
                                            <Tooltip title="Validar Login">
                                                <IconButton
                                                    disabled={!auth.hasPerm("dns_node.update")}
                                                    onClick={() => {
                                                        const id = tableMeta.rowData[0]
                                                        api.get(`/dns/node/${id}/valid_credentials`).then(res => {
                                                            if (res.data?.error) {
                                                                notify.setNotify({ open: true, message: res.data.error, severity: 'error' })
                                                                return
                                                            }
                                                            // 202 — task enfileirada, abre HUD
                                                            window.dispatchEvent(new Event('task-enqueued'))
                                                            notify.setNotify({ open: true, message: 'Validação enfileirada — acompanhe na fila', severity: 'info' })
                                                        }).catch(err => {
                                                            notify.setNotify({ open: true, message: err.response?.data?.detail || err.message, severity: 'error' })
                                                        })
                                                    }}
                                                >
                                                    <KeyIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Sincronizar">
                                                <IconButton
                                                disabled={!auth.hasPerm("dns_node.update")}
                                                onClick={() => {
                                                    const id = tableMeta.rowData[0]
                                                    Swal.fire({
                                                        title: 'Sincronizar servidor DNS?',
                                                        text: 'A sincronização irá APAGAR os registros existentes e adicionar os do sistema.',
                                                        icon: 'warning',
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Sim, sincronizar',
                                                        cancelButtonText: 'Cancelar',
                                                        confirmButtonColor: '#e01b29',
                                                    }).then((result) => {
                                                        if (!result.isConfirmed) return
                                                        api.get(`/dns/node/${id}/sync`).then(res => {
                                                            if (res.data?.error) {
                                                                notify.setNotify({ open: true, message: res.data.error, severity: 'error' })
                                                                return
                                                            }
                                                            window.dispatchEvent(new Event('task-enqueued'))
                                                            notify.setNotify({ open: true, message: 'Sincronização enfileirada — acompanhe na fila', severity: 'info' })
                                                        }).catch(err => {
                                                            notify.setNotify({ open: true, message: err.response?.data?.detail || err.message, severity: 'error' })
                                                        }).finally(() => {
                                                        })
                                                    })
                                                }}
                                                >
                                                <SyncIcon/>
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Excluir">
                                                <IconButton
                                                disabled={!auth.hasPerm("dns_node.delete")}
                                                onClick={() => {
                                                    const id = tableMeta.rowData[0]
                                                    const nome = tableMeta.rowData[1]
                                                    Swal.fire({
                                                        title: 'Excluir servidor DNS?',
                                                        text: `O servidor '${nome}' sai da lista e para de receber as syncs. Você não poderá reverter isso.`,
                                                        icon: 'warning',
                                                        showCancelButton: true,
                                                        confirmButtonText: 'Sim, excluir',
                                                        cancelButtonText: 'Cancelar',
                                                        confirmButtonColor: '#e01b29',
                                                    }).then((result) => {
                                                        if (!result.isConfirmed) return
                                                        setLoading(true)
                                                        delete_one('/dns/node', id).then(res => {
                                                            // handleQueuedResponse trata { error } com HTTP 200 —
                                                            // padrão do backend. Sem ele, falha vira "sucesso".
                                                            handleQueuedResponse(res, notify, {
                                                                successMessage: 'Servidor DNS removido com sucesso.',
                                                            })
                                                        }).catch(e => {
                                                            notify.setNotify({ open: true, message: e.response?.data?.detail || e.message, severity: 'error' })
                                                        }).finally(() => {
                                                            setLoading(false)
                                                            setRefresh(true)
                                                        })
                                                    })
                                                }}
                                                >
                                                <DeleteIcon/>
                                                </IconButton>
                                            </Tooltip>
                                       
                                    </>
                                )
                            }
                        }
                    }
                ]}

            />
        </>
    )
}




function FormItem({ id, open, handlerClose, handlerSubmit, btnClose = 'Fechar', btnSubmit = 'Salvar' }) {
    const notify = useNotify()
    const error = useFormError()
    const [isLoaded, setIsLoaded] = useState(true)
    useEffect(() => {
        setState(modelState)
        error.setErrors([])
        if (id) {
            setIsLoaded(false)
            get_one('/dns/node', id).then(res => {
                setState(res.data.data)
                setIsLoaded(true)
            }).catch(e => {
                console.log(e)
                setIsLoaded(true)
            })
        }
    }, [id])
    const modelState = {
        ip: '',
        name: '',
        username: '',
        password: '',
        port: '',
        active: true,
        role: 'recursive',
        hostname: '',
    }
    const [state, setState] = useState(modelState)
    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    }

    const handleResponse = (res, successMsg) => {
        // Backend pode retornar:
        //   { error: "msg" }      → ResponseError (falha de IntegrityError/etc)
        //   { errors: [...] }     → validação de campos
        //   { data: {...} }       → sucesso (Response com payload)
        const data = res?.data || {}
        if (data.errors) {
            error.setErrors(data.errors)
            return false
        }
        if (data.error) {
            notify.setNotify({ open: true, message: data.error, severity: 'error' })
            return false
        }
        handlerClose()
        notify.setNotify({ open: true, message: successMsg, severity: 'success' })
        error.setErrors([])
        return true
    }

    const wrapperSubmit = () => {
        if (id) {
            update('/dns/node', id, state)
                .then(res => handleResponse(res, 'Servidor DNS atualizado com sucesso'))
                .catch(e => notify.setNotify({ open: true, message: e.message, severity: 'error' }))
        } else {
            create('/dns/node/create', state)
                .then(res => handleResponse(res, 'Servidor DNS criado com sucesso.'))
                .catch(e => notify.setNotify({ open: true, message: e.message, severity: 'error' }))
        }
        handlerSubmit()
    }
    return (
        <Box component={"form"}
            onSubmit={wrapperSubmit}
            sx={{ m: 2 }}
            display={'flex'}
            flexWrap={'wrap'}
        >

            <FormDialog
                isLoaded={isLoaded}
                title={
                    <Typography variant="h6" component="div">{id ? 'Editar' : 'Adicionar'} Servidor DNS</Typography>
                }
                open={open}
                handlerSubmit={wrapperSubmit}
                handlerClose={handlerClose}
                btnSubmit={btnSubmit}
                btnClose={btnClose}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                    <TextField
                        sx={{ mb: 2, mt: 1 }}
                        error={error.verify("name")}
                        helperText={error.msgError("name")}
                        label='Descrição'
                        name={"name"}
                        value={state.name}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('ip')}
                        helperText={error.msgError('ip')}
                        label='IP'
                        value={state.ip}
                        name={'ip'}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('username')}
                        helperText={error.msgError('username')}
                        label='Usuário'
                        name={'username'}
                        value={state.username}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('password')}
                        helperText={error.msgError('password')}
                        label='Senha'
                        name={'password'}
                        value={state.password}
                        onChange={handleChange}
                    />
                    <TextField
                        sx={{ mb: 2 }}
                        error={error.verify('port')}
                        helperText={error.msgError('port')}
                        label='Porta'
                        name={'port'}
                        value={state.port}
                        onChange={handleChange}
                    />

                    {/* Papel do servidor — recursivo ou reverso */}
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
                            Papel do servidor
                        </Typography>
                        <ToggleButtonGroup
                            exclusive
                            fullWidth
                            size="small"
                            value={state.role || 'recursive'}
                            onChange={(e, v) => { if (v) setState({ ...state, role: v }) }}
                        >
                            {Object.entries(ROLES).map(([k, r]) => (
                                <ToggleButton key={k} value={k}>{r.label}</ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 0.5 }}>
                            {(ROLES[state.role] || ROLES.recursive).help}
                        </Typography>
                    </Box>
                    {state.role === 'reverse' && (
                        <TextField
                            sx={{ mb: 2 }}
                            label='Hostname (FQDN)'
                            name='hostname'
                            value={state.hostname || ''}
                            onChange={handleChange}
                            placeholder='ns1.exemplo.net.br.'
                            helperText='Entra como NS (e SOA) nas zonas reversas geradas pra este servidor.'
                        />
                    )}

                    {/* Switch ativo/inativo — destacado */}
                    <Box sx={{
                        display: 'flex', alignItems: 'center', gap: 1, mb: 1,
                        bgcolor: state.active ? 'rgba(46,125,50,0.08)' : 'rgba(0,0,0,0.04)',
                        px: 1.5, py: 0.5, borderRadius: 1,
                        border: '1px solid',
                        borderColor: state.active ? 'success.main' : 'divider',
                    }}>
                        <Switch
                            checked={!!state.active}
                            onChange={(e) => setState({ ...state, active: e.target.checked })}
                            color="success"
                        />
                        <Box>
                            <Typography variant="body2" sx={{
                                fontWeight: 600,
                                color: state.active ? 'success.main' : 'text.secondary',
                            }}>
                                {state.active ? 'Servidor ligado' : 'Servidor desligado'}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                {state.active
                                    ? 'Vai receber as atualizações de DNS automaticamente.'
                                    : 'Não recebe atualizações até ser ligado de novo.'}
                            </Typography>
                        </Box>
                    </Box>

                </Box>

            </FormDialog>
        </Box>
    )
}


